import React, { useEffect, useState } from "react";
//import { permissions } from "../../services/Authorization/authService";
import DataTable, { pageSizeKey } from "../helper/dataTable/dataTable";
import { useLocation, useHistory } from "react-router-dom";
import {
  Button,
  Popconfirm,
  message,
  Space,
  Input,
  Tooltip,
  Divider,
} from "antd";
import { Link } from "react-router-dom";
import _t from "../../languages/translate";
import {
  EyeTwoTone,
  DeleteTwoTone,
  CloseCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  getPagers,
  remove,
} from "../../services/Items/InventoryMatchingService";
import moment from "moment";

const PageInventoryMatching = () => {
  const searchKey = "search";
  let history = useHistory();
  const location = useLocation();
  const [meta, setMeta] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const savedPageSize = localStorage.getItem(pageSizeKey);

  const tableConfig = [
    {
      title: _t("strCode"),
      dataIndex: "code",
      key: "code",
      width: 100,
    },
    {
      title: _t("strDate"),
      dataIndex: "date",
      key: "date",
      width: 100,
      render: (_, record) => (
        <span> {moment(record.date).format('L')} </span>
      )
    },
    {
      title: _t("strStore"),
      dataIndex: "storeName",
      key: "storeName",
      width: 100,
    },
    {
      title: _t("strNote"),
      dataIndex: "note",
      key: "note",
      width: 100,
    },
    {
      title: _t("strActions"),
      key: "edit",
      width: 40,
      align: "center",

      // hidden:
      //   permissions._ItemUnit_Delete && permissions._ItemUnit_Put
      //     ? false
      //     : true,

      render: (_, record) => (
        <Space size="large">
          {/* {permissions._ItemUnit_Put ? ( */}
          <Tooltip title={_t("strShow")} >
            <Link style={{ fontSize: "20px" }} to={`/inventoryMatching/${record.id}`}>
              <EyeTwoTone />
            </Link>
          </Tooltip>
          {/* ) : undefined} */}

          {/* {permissions._ItemUnit_Delete ? ( */}
          <Tooltip title={_t("strDelete")} color="red">
            <Popconfirm
              title={_t("strSureToDelete")}
              onConfirm={() => onDelete(record.id)}
            >
              <DeleteTwoTone
                twoToneColor="#eb2f96"
                style={{ fontSize: "20px" }}
              />
            </Popconfirm>
          </Tooltip>
          {/* ) : undefined} */}
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getView(true);
    getSearch();
  }, [location.search, savedPageSize]);

  const getView = async (load) => {
    setIsLoading(load);
    const query = new URLSearchParams(location.search);
    if (savedPageSize && !query.has(pageSizeKey))
      query.set(pageSizeKey, savedPageSize);
    try {
      const { data: responce } = await getPagers(query.toString());

      if (responce.data.length > 0) {
        setDataSource(responce.data);
        setMeta(responce.meta);
      } else {
        setDataSource([]);
      }
    } catch (error) {
      if (error.response) {
        message.error(error.response.data?.message || _t("msgUnknownError"), 3);
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
      } else {
        message.error(_t("msgUnknownError"), 3);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const onDelete = async (id) => {
    try {
      const response = await remove(id);
      getView(false);
      message.success(response.data.message);
    } catch (ex) {
      message.error(ex.response?.data?.message || _t("msg.not_deleted"));
    }
  };

  const getSearch = () => {
    const query = new URLSearchParams(history.location.search);
    setSearchValue(query.get(searchKey));
  };

  const handleSearch = async (value) => {
    const query = new URLSearchParams(history.location.search);
    if (!value) query.delete(searchKey);
    else query.set(searchKey, value);
    history.push({
      pathname: history.location.pathname,
      search: query.toString(),
    });
  };

  const handleSearchClear = () => {
    setSearchValue("");
    const query = new URLSearchParams(history.location.search);
    query.delete(searchKey);
    history.push({
      pathname: history.location.pathname,
      search: query.toString(),
    });
  };

  return (
    <>
      <DataTable
        rowKey="id"
        hideSearch
        expandIconColumnIndex={0}
        saveColumnsProps="InventoryMatching"
        columns={tableConfig}
        loading={isLoading}
        dataSource={dataSource}
        meta={meta}
        size="small"
        bordered
        rowClassName={(record, index) =>
          record.rowType === "Total"
            ? "treeMain-row"
            : record.rowType === "Detail"
              ? "treeDetails-row"
              : index % 2 === 0
                ? "table-row-light"
                : "table-row-dark"
        }
        extra={
          <Space>
            {/* {permissions._ItemUnit_Post && ( */}
            <Button
              style={{ width: 150, borderRadius: 5 }}
              type="primary"
              size="small"
            >
              <Link to={`/inventoryMatching/new`}>{_t("strAddNew")}</Link>
            </Button>
            {/* )} */}

            <Divider type="vertical" />
            <Input
              defaultValue={
                new URLSearchParams(history.location.search).get("search") ||
                undefined
              }
              onChange={(e) => setSearchValue(e.target?.value)}
              placeholder={_t("strSearch")}
              onPressEnter={(e) => handleSearch(e.currentTarget.value)}
              bordered={false}
              size="small"
              value={searchValue}
              prefix={
                searchValue === "" || searchValue === null ? (
                  <SearchOutlined style={{ color: "#a5a5a5" }} />
                ) : (
                  <CloseCircleOutlined
                    onClick={() => handleSearchClear()}
                    style={{ color: "#a5a5a5" }}
                  />
                )
              }
            />
            <Divider type="vertical" />
          </Space>
        }
      />
    </>
  );
};

export default PageInventoryMatching;
